<div
  class="form-field"
  [ngClass]="{
    'form-field--success': color() === 'success',
    'form-field--error': color() === 'error' || hasErrors,
    'form-field--white': color() === 'white',
    'form-field--default': variant() === 'default',
  }">
  @if (label()) {
    <label class="form-field__label">
      {{ label() | translate }}
      @if (!!this.messages()['required']) {
        <span class="form-field__required">*</span>
      }
      @if (subLabel()) {
        <span [class]="'form-field__sub-label ' + CustomCssSubLabel()">{{
          subLabel() | translate
        }}</span>
      }
    </label>
  }

  <div class="form-field__input">
    @if (isTextAreaMode()) {
      <textarea
        class="field-textarea"
        [disabled]="disabled"
        [ngClass]="{
          'px-8': !icon,
          'pr-16 pl-42': icon() && iconPosition() === 'left',
          'pl-16 pr-42': icon() && iconPosition() === 'right',
        }"
        [(ngModel)]="value"
        (ngModelChange)="propagateChange($event)"
        [placeholder]="placeholder() | translate"
        [rows]="rows()"
        [cols]="cols()"
        (focus)="onFocus()"
        (blur)="onBlur()"
        [attr.name]="name()"></textarea>
    } @else {
      <div>
        @if (type() === 'number') {
          <!-- input type number -->
          <input
            class="field-text-box"
            pwjCommasSeparateNumbers
            pwjOnlyNumber
            [isFloatNumber]="true"
            [disabled]="disabled"
            [readOnly]="isReadOnly()"
            [ngClass]="{
              'px-8': !icon(),
              'pr-16 pl-42 rtl:pr-42 rtl:pl-16':
                icon() && iconPosition() === 'left',
              'pl-16 pr-42': icon() && iconPosition() === 'right',
              '!px-58': icon() === 'null-space',
            }"
            [(ngModel)]="value"
            (ngModelChange)="propagateChange($event)"
            [placeholder]="placeholder() | translate"
            (focus)="onFocus()"
            (blur)="onBlur()"
            [attr.name]="name()" />
        } @else {
          <!-- input other types -->
          <input
            class="field-text-box"
            [type]="type() === 'password' ? checkType() : type()"
            [disabled]="disabled"
            [readOnly]="isReadOnly()"
            [ngClass]="{
              'px-8': !icon(),
              'pr-16 pl-42 rtl:pr-42 rtl:pl-16':
                icon() && iconPosition() === 'left',
              'pl-16 pr-42': icon() && iconPosition() === 'right',
              '!px-58': icon() === 'null-space',
            }"
            [(ngModel)]="value"
            (ngModelChange)="propagateChange($event)"
            [placeholder]="placeholder() | translate"
            (focus)="onFocus()"
            (blur)="onBlur()"
            [attr.name]="name()" />
        }
      </div>
    }

    <!-- left icon -->
    @if (icon() && iconPosition() === 'left') {
      <i
        class="iconsax field-left-icon"
        [ngClass]="iconClasses()"
        [attr.icon-name]="icon()"></i>
    }
    <!-- right icon -->
    @if (icon() && iconPosition() === 'right') {
      <i
        class="iconsax field-right-icon"
        [ngClass]="iconClasses()"
        [attr.icon-name]="icon()"></i>
    } @else if (type() === 'password') {
      <i
        class="iconsax field-right-icon cursor-pointer"
        [ngClass]="iconClasses()"
        [attr.icon-name]="showPassword ? 'eye' : 'eye-slash'"
        (click)="togglePasswordVisibility()"></i>
    }
  </div>

  @if (hasErrors) {
    <div class="form-field__input-errors">
      @for (error of messages() | keyvalue; track error) {
        @if (getErrors?.[error.key]) {
          <span class="form-field__input-error">{{
            error.value | translate
          }}</span>
        }
      }
    </div>
  }
</div>
